import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';
import { RouterStateUrl } from './custom-route-serializer';

export const getRouterReducerState =
  createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

export const getUrl = createSelector(getRouterReducerState, (state) => state && state.state.url);

export const getProjectId = createSelector(
  getRouterReducerState,
  (state) => state && state.state.params.projectId,
);

export const getSchemaProjectId = createSelector(
  getRouterReducerState,
  (state) => state && Number(state.state.params.schemaProjectId),
);

export const getSchemaDefinitionName = createSelector(
  getRouterReducerState,
  (state) => state && state.state.params.definitionName,
);
